const { hostname, protocol, port } = window.location;

let tempUserMgmtService;
let tempAppServerAddr;
let tempFaviconUrl;
let tempCenterLogoUrl;
let tempLeftLogoUrl;

if (hostname === "localhost") {
  tempUserMgmtService = process.env.REACT_APP_USER_BASE_URL;
  tempAppServerAddr = process.env.REACT_APP_APP_SERVER_ADDRESS;
  tempFaviconUrl =
    process.env.REACT_APP_USER_BASE_URL +
    "/global-conf/commondashboard/favicon.png";
  tempCenterLogoUrl =
    process.env.REACT_APP_USER_BASE_URL + "/global-conf/commondashboard/";
  tempLeftLogoUrl =
    process.env.REACT_APP_USER_BASE_URL + "/global-conf/commondashboard/";
} else {
  tempUserMgmtService = `${protocol}//${hostname}`;
  tempAppServerAddr = `${protocol}//${hostname}`;
  tempFaviconUrl = `${protocol}//${hostname}/global-conf/commondashboard/favicon.png`;
  tempCenterLogoUrl = `${protocol}//${hostname}/global-conf/commondashboard/`;
  tempLeftLogoUrl = `${protocol}//${hostname}/global-conf/commondashboard/`;
}

export const baseUrl = ""; //update whenever required
export const appserveraddr = tempAppServerAddr;
export const deviceBaseUrl = ""; //update whenever required
export const userMgmtService = tempUserMgmtService;
export const authBaseUrl = tempUserMgmtService;
export const faviconUrl = tempFaviconUrl;
export const centerLogoUrl = tempCenterLogoUrl;
export const leftLogoUrl = tempLeftLogoUrl;
//permissions
export const getAllPermissions = "/auth/permissions/permissions";
export const managemaster = "/lms/master-data";
export const getMineDetails = "/lms/mines/mines";

export const getAppModules = "/auth/permissions/modules";

//Executive Dashboard
export const getScrollWidgetData = "/v1/executive-dashboard/scrollWidget";
export const getWidgetsData = "/v1/executive-dashboard/widgetitem";
export const getDashboardEnvOptions =
  "/v1/executive-dashboard/dashboard_environment_dropdown";
export const getEnvChartWidgetData =
  "/v1/executive-dashboard/dashboard_environment_chartdata/";
export const getDashboardMapOptions =
  "/v1/executive-dashboard/dashboard_map_dropdown";
export const getDashbaordMapViewData = "/v1/executive-dashboard/dashboard_map/";
export const getDashboardSOPsData = "/v1/executive-dashboard/dashboard_sop";
export const getDashboardAlertsData = "/v1/executive-dashboard/dashboard_alert";

// Solutions
export const getSmartPoleHeaderOptions = "/v1/solution/smartpole_header_option";
export const getSolutionsMapOptions = "/v1/solution/solution_map_option";
export const getSolutionsMapData = "/v1/solution/solution_map";
export const getSolutionScrollData = "/v1/solution/solution_scroll";

//Environment
export const getEnvironmentMapData = "/v1/environment/environment_map";
export const getEnvironmentCardsData =
  "/v1/environment/environment_parametercard/";
export const getEnvironmentTemparatureData =
  "/v1/environment/environment_temperature/";
export const getComparisionOptions = "/v1/environment/comparision_dropdown";
export const getEnvironmentComparisitionData =
  "/v1/comparision/comparision_data/";
export const getComparisionData = "/v1/comparision/comparision_data/";
export const getEnvironmentHumidityData =
  "/v1/environment/environment_humidity/";
export const getEnvironmentAirQualityIndex =
  "/v1/environment/environment_air_quality_index/";
export const getEnvironmentsParametersData =
  "/v1/environment/environment_airqualityparameter/";

//Surveillance
export const getSurveillancePresetData = "/v1/surveillance/surveillance_preset";
export const getSurveillanceOptions = "/v1/surveillance/surveillance_location";
export const getSurveillanceTriggerData =
  "/v1/surveillance/surveillance_trigger/";

//Lighting
export const getLightingMapData = "/v1/lighting/lighting_map";
export const getLightingMapOptions = "/v1/lighting/lighting_map_option";
export const getLightingEnergyConsumptionData =
  "/v1/lighting/lighting_energyconsumption/";
export const getLightingVoltageData = "/v1/lighting/lighting_voltage/";
export const getLightingHealthData = "/v1/lighting/lighting_health/";
export const getLightingStatus = "/v1/lighting/lighting_status/";
export const getStreetLightActions = "/v1/streetlight/lighting_devices/"; //{locationId}
export const changeDeviceState = "/v1/command/lighting/lighting_device_state";
export const changeDeviceIntensity = "/v1/command/lighting/lighting_intensity";

//Events
export const getAllEventsIncidents = "/sop/getallevents";
export const insertEvent = "/sop/insertevent";
export const updateEventById = "/sop/updateeventbyid/{EVENT}";
export const generateProcessInstance =
  "/sop/createprocessinstance/{PROCESSKEY}";
export const getsopInfoWithImage =
  "/sop/status?processkey={PROCESSKEY}&processInstanceId=";
export const createsopurl = "/sop";
export const loadecbiframeurl = "/sip-phone/";
export const getallalerts = "/sop/getallalerts";
export const updatealertaseventbyid = "/sop/updatealertaseventbyid/{ALERTID}";

//Wifi
export const getWifiMapOptions = "/v1/wifi/wifi_map_dropdown";
export const getWifiMapData = "/v1/wifiData/wifi_map";
export const getWifiDevicesData = "/v1/wifiData/wifi_alerts/";
export const getWifiStatusData = "/v1/wifiData/wifi_status/";

//ECB
export const getECBCardData = "/v1/ecb/ecb_card/"; //{locationId (ex:0)}
export const getECBMapData = "/v1/ecb/ecb_map";
export const getECBIncidentsData = "/v1/ecb/ecb_incidents/"; //{locationId (ex:0)}
export const getECBNoofCallsData = "/v1/ecb/ecb_noofcalls/";
export const getECBTableData = "/v1/ecb/ecb_table/";

//PAS
export const getLocationDataPAS = "/v1/pas/pas_location/"; //{locationId (ex:0)}
export const getMapDataPAS = "/v1/pas/pas_map";
export const getMsgCatDataPAS = "/v1/pas/pas_message_category/"; //{locationId (ex:0)}
export const getConfiugreNewMessageOptions = "/v1/pas/configure_new_message";
export const getCurrentLiveMsg = "/v1/pas/current_live_message_pas";
export const getNumberOfMsgPAS = "/v1/pas/pas_numberofmessage/";
export const getTableDataPAS = "/v1/pas/pas_table/";
export const getPutOutOptionsPAS = "/v1/pas/go_live_option";
export const getMediaOptionsPAS = "/v1/pas/media_option";
export const uploadPasAudio = "/v1/command/pas/audio";
export const submitConfigMsgForm = "/v1/command/pas/play";

//VMD
export const getMapDataVMD = "/v1/vmd/vmd_map";
export const getLocationDataVMD = "/v1/vmd/vmd_location/";
export const getMsgCatDataVMD = "/v1/vmd/vmd_message_category/";
export const getCurrentLiveMsgVMD = "/v1/vmd/current_live_message_vmd";
export const getConfiugreNewMsgOptionsVMD = "/v1/vmd/configure_new_message";
export const getTableDataVMD = "/v1/vmd/vmd_table/";
export const getNumberOfCallsVMD = "/v1/vmd/vmd_numberofcalls/";
export const getScrollTypeOptions = "/v1/vmd/scroll_type_option";
export const uploadVmdMultimedia = "/v1/command/vmd/multimedia";
export const submitConfigFormVMD = "/v1/command/vmd/play";

//Incident Management
export const getIncidentCardData = "/v1/incident/incident_card/"; //{locationId (ex:0)}
export const getIncidentMapData = "/v1/incident/incident_map";
export const getIMIncidentsData = "/v1/incident/incident_chart/"; //{locationId (ex:0)}
export const getIMNoofIncidentsData = "/v1/incident/im_numberofincidents/";
export const getIncidentTableData = "/v1/incident/incident_table/";

//LMS - Transporter
export const manageTransporter = "lms/transporter";

//user image
export const getUserImage = "/auth/media/file/";
export const postImage = "/auth/profile/change_picture";
export const authUserData = "/auth/profile";
export const vehicleChecklistReports = "/lms/vehicle_inspection/report";
export const changePassword = "/auth/profile/change_password";
